import { useAuth } from "shared/contexts/Auth/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import BackgroundShape from "../backgroundshape/BackgroundShape";
import { DesktopPainel } from "./DesktopPainel";
import { Buscador } from "./headerbusca/buscador/Buscador";
import { UserPanel } from "../userpanel/UserPanel";
import styles from "./MainHeader.module.scss";

export const MainHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loadingAuth, perfilAtivo } = useAuth();
  const isHome = location.pathname === "/";
  const isLogado = !!user;

  if (loadingAuth) {
    return null;
  }

  /* ===============================
     NÃO LOGADO
  =============================== */

  if (!isLogado) {
    return (
      <header className={styles.containerOff}>
        <BackgroundShape
          size={600}
          top={-180}
          right={-80}
        />

        <div className={styles.desktopOffContent}>
          <img
            className={styles.logoEmpresa}
            src="/imagens/logo.png"
            alt="Logo"
            onClick={() => {
              navigate("/", {
                state: {
                  resetCategoria: true,
                  refreshHome: Date.now(),
                },
              });
            }}
          />

          <div className={styles.buscaDesktopOff}>
            <Buscador />
          </div>

          {isHome && (
            <button
              type="button"
              className={styles.homeButton}
              onClick={() => navigate("/login")}
            >
              Entrar
            </button>
          )}
        </div>
      </header>
    );
  }

  /* ===============================
     LOGADO
  =============================== */

  const classePerfil =
    perfilAtivo === "vendedor"
      ? styles.containerVendedor
      : styles.containerComprador;

  const isVendedor = perfilAtivo === "vendedor";

  return (
    <header className={`${styles.container} ${classePerfil}`}>
      <BackgroundShape
        size={400}
        top={-180}
        right={-80}
      />

      <div className={styles.cardNav}>
        <img
          className={styles.logoEmpresa}
          src={
            isVendedor
              ? "/imagens/menuLogo.png"
              : "/imagens/menuLogoBranco.png"
          }
          alt="Logo"
          onClick={() => {
            navigate("/", {
              state: {
                resetCategoria: true,
                refreshHome: Date.now(),
              },
            });
          }}
        />

        <DesktopPainel perfilAtivo={perfilAtivo} />

        <UserPanel />
      </div>
    </header>
  );
};